import { useEffect, useState } from "react"
import BlogNavbar from "../components/BlogNavbar"
import getDateAndTime from "../../../helper/getDateAndTime"
import getReadPerMinute from "../../../helper/getReadPerMinute"
import { ReactMarkdown } from "react-markdown/lib/react-markdown"
import { useParams } from "react-router-dom"
import api from "../../../api"
import MarkdownComponents from "../components/MarkdownComponents"
import rehypeRaw from "rehype-raw"

const tempDate = "2023-06-28T05:35:09.000Z"
const tempContent = `# asd 
Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla euismod, nisl eget ultricies ultricies, nunc nisl aliquam nunc, vitae aliq`

const BlogPost = () => {

  const [blogData, setBlogData] = useState({})
  const [date, setDate] = useState(getDateAndTime(tempDate))
  const [content, setContent] = useState(tempContent)
  const [type, setType] = useState('')

  const { id: blogID } = useParams();
  useEffect(() => {

    const getPostfromID = async () => {
      const response = await api.get('/post/' + blogID);
      setBlogData(response.data);
      setDate(getDateAndTime(response.data.created_at))
      setContent(response.data.content)
      setType(response.data.post_type)
    }

    getPostfromID();

  }, [blogID])





  return (
    <div>
      <BlogNavbar />
      <div className="container blogPostContainer">
        <div className="row g-0">
          <div className="col-lg-3" />


          <div className="col-lg-6 ">
            <h1>{blogData.title}</h1>

            <div className="d-flex justify-content-between">

              <small><small className="text-secondary">Published on</small> {date[1]} · {date[0]}</small>

              <small>{getReadPerMinute(content)} min read</small>
            </div>

            <hr className="blogPostHr mb-5" />

            {type !== 'music' && <img className="w-75 my-5 mx-auto d-block" src={blogData.thumbnail} alt="thumbnail" />}


            {/* <ReactMarkdown className={`w-100 h-100 blogPostContent`} components={{img: ({src, alt, title, ...props}) => <img style={{width: '100px'}} src={src} alt={alt} title={title} {...props}/>}} children={blogData.content} /> */}

            <ReactMarkdown className={`w-100 blogPostContent`} rehypePlugins={[rehypeRaw]} children={blogData.content} components={MarkdownComponents} />

            <hr className="blogPostHr" />


          </div>

          <div className="col-lg-3" />
        </div>

      </div>
    </div>
  )
}

export default BlogPost